"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EtherspotWallet__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEntryPoint",
                name: "anEntryPoint",
                type: "address",
            },
            {
                internalType: "contract IEtherspotWalletFactory",
                name: "anWalletFactory",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IEntryPoint",
                name: "entryPoint",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "EtherspotWalletInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EtherspotWalletReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newGuardian",
                type: "address",
            },
        ],
        name: "GuardianAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedGuardian",
                type: "address",
            },
        ],
        name: "GuardianRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnerAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedOwner",
                type: "address",
            },
        ],
        name: "OwnerRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "discardedBy",
                type: "address",
            },
        ],
        name: "ProposalDiscarded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newOwnerProposed",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
        ],
        name: "ProposalSubmitted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newTimelock",
                type: "uint256",
            },
        ],
        name: "ProposalTimelockChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newOwnerProposed",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "approvalCount",
                type: "uint256",
            },
        ],
        name: "QuorumNotReached",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "addDeposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newGuardian",
                type: "address",
            },
        ],
        name: "addGuardian",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "addOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_newTimelock",
                type: "uint256",
            },
        ],
        name: "changeProposalTimelock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "discardCurrentProposal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "entryPoint",
        outputs: [
            {
                internalType: "contract IEntryPoint",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dest",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "func",
                type: "bytes",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "dest",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "value",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "func",
                type: "bytes[]",
            },
        ],
        name: "executeBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "address",
                name: "ownerProposed_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "approvalCount_",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "guardiansApproved_",
                type: "address[]",
            },
            {
                internalType: "bool",
                name: "resolved_",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "proposedAt_",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "guardianCosign",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "guardianCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "guardianPropose",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "anOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "isGuardian",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "isOwner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "ownerCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalTimelock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_guardian",
                type: "address",
            },
        ],
        name: "removeGuardian",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "removeOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256",
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "validationData",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "withdrawAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawDepositTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class EtherspotWallet__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(anEntryPoint, anWalletFactory, overrides) {
        return super.deploy(anEntryPoint, anWalletFactory, overrides || {});
    }
    getDeployTransaction(anEntryPoint, anWalletFactory, overrides) {
        return super.getDeployTransaction(anEntryPoint, anWalletFactory, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EtherspotWallet__factory = EtherspotWallet__factory;
EtherspotWallet__factory.bytecode = _bytecode;
EtherspotWallet__factory.abi = _abi;
